<template>
	<Panel :contentPaddingTop="12" class="update-log">
		<el-alert
			title="“修改记录”中有待处理任务时，建议不要进行重复操作，以免在修改任务执行过程中覆盖当前操作！"
			:closable="false"
			type="warning"
			show-icon
		/>
		<platform-tab class="mt-4" @change="handleClick" :platformId="platformId">
			<el-table :data="list" header-row-class-name="table-header-row" row-class-name="table-row">
				<el-table-column label="修改订单信息" width="230">
					<template v-slot="{ row }">
						<div
							>订单量<span class="ml-4 primary-color">{{ row.update_total }}</span></div
						>
						<div
							>归属人<span class="ml-4 primary-color">{{ row.belong_partner_name || '无归属' }}（{{ roles[row.type] }}）</span></div
						>
					</template>
				</el-table-column>
				<el-table-column min-width="150">
					<template v-slot="{ row }">
						<template v-if="row.type == 'talent_partner'">
							<div
								>达人分成比<span class="ml-4 primary-color">{{ row.scale || '--' }}%</span></div
							>
							<div
								>团长分成比<span class="ml-4 primary-color">{{ row.partner_scale || '--' }}%</span></div
							>
						</template>
						<template v-else-if="row.type == 'bd_partner'">
							<div
								>分成比<span class="ml-4 primary-color">{{ row.scale || '--' }}%</span></div
							>
						</template>
					</template>
				</el-table-column>
				<el-table-column label="修改时间" prop="add_time" min-width="150"></el-table-column>
				<el-table-column label="修改完成时间" prop="update_time" min-width="150"></el-table-column>
				<el-table-column label="修改人" prop="partner_name" min-width="100"></el-table-column>
				<el-table-column label="状态" min-width="80">
					<template v-slot="{ row }">
						<div class="tag" :class="['loading-tag', 'success-tag', 'error-tag'][row.task_status]">{{ row.task_status_name }}</div>
					</template>
				</el-table-column>
			</el-table>
			<yx-pagination
				:total="total"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			/>
		</platform-tab>
	</Panel>
</template>

<script>
import PlatformTab from '@/components/platformTab';
import { mapGetters } from 'vuex';
import { getBelongList } from '@/api/shopManage';
import { zsRoleType, drRoleType } from '@/utils/dataMap';

export default {
	name: 'importLog',
	data() {
		return {
			list: [],
			roles: {
				talent_partner: drRoleType.name,
				bd_partner: zsRoleType.name,
			},
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			platformId: '',
			total: 0,
		};
	},
	computed: {
		...mapGetters(['defaultPlatform']),
	},
	created() {
		const _platform_id = +this.$route.query.platform_id;
		this.platformId = _platform_id ? _platform_id : this.defaultPlatform;
		this.pageInfo.platform_id = this.platformId;
		this.getList();
	},
	methods: {
		sizeChange(size) {
			this.pageInfo.page_size = size;
			this.getList();
		},
		currentChange(index) {
			this.pageInfo.page_index = index;
			this.getList();
		},
		handleClick(val) {
			this.platformId = val;
			this.pageInfo.platform_id = this.platformId;
			this.getList();
		},
		async getList() {
			const { code, data: { list = [], page = {} } = {} } = await getBelongList(this.pageInfo);
			if (code !== 0) return;
			this.list = list;
			this.total = page.item_total;
		},
	},
	components: {
		PlatformTab,
	},
};
</script>

<style lang="less" scoped>
.update-log {
	.tag {
		display: flex;
		align-items: center;
		&::before {
			content: '';
			width: 6px;
			height: 6px;
			border-radius: 50%;
			margin-right: 8px;
		}
		&.loading-tag {
			color: #fa8f14;
			&::before {
				background-color: #fa8f14;
			}
		}
		&.error-tag {
			color: #f03525;
			&::before {
				background-color: #f03525;
			}
		}
		&.success-tag {
			color: #00c840;
			&::before {
				background-color: #00c840;
			}
		}
	}
}
</style>
